import React, { useEffect, useState } from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { useHistory, useLocation } from 'react-router-dom';
import { dataService } from '../../Services/data.service'
import { scissorTypes, scissorStates } from '../../Config/scissorStates'
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import { toast } from 'react-toastify';
import { machineScissorZone } from '../../Config/constants'

export default function SelectedWorkstation(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();
    let location = useLocation();

    const [usedZones, setUsedZones] = useState([])
    const [showZones, setShowZones] = useState([false])
    const [upperScissorStatus, setUpperScissorStatus] = useState(null)
    const [lowerScissorStatus, setLowerScissorStatus] = useState(null)

    useEffect(() => {
        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            let workstation = workstationsWithScissorStatusses.find(x => x.id === props.workstation.selectedWorkstation)
            let upperStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
            let lowerStatus = workstation.scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)

            if (JSON.stringify(upperScissorStatus) !== JSON.stringify(upperStatus)) {
                setUpperScissorStatus(upperStatus)
            }
            if (JSON.stringify(lowerScissorStatus) !== JSON.stringify(lowerStatus)) {
                setLowerScissorStatus(lowerStatus)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        let zones = [{ zone: "A", scissor: 1, used: false, orderId: null, orderRef: null },
        { zone: "B", scissor: 1, used: false, orderId: null, orderRef: null },
        { zone: "C", scissor: 1, used: false, orderId: null, orderRef: null },
        { zone: "D", scissor: 1, used: false, orderId: null, orderRef: null },
        { zone: "E", scissor: 1, used: false, orderId: null, orderRef: null },
        { zone: "F", scissor: 1, used: false, orderId: null, orderRef: null }]


        dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {

            orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)
            var o;
            for (o = 0; o < orders.length; o++) {
                if (orders[o].bowMetaData) {

                    let bowMetaData = JSON.parse(orders[o].bowMetaData)
                    let metaData = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0]
                    var i;
                    for (i = 0; i < props.zones.length; i++) {
                        var y;
                        for (y = 0; y < metaData.UsedZones.length; y++) {
                            if (metaData.UsedZones[y].ZoneId === props.zones[i].id) {
                                if (props.zones[i].code.includes(scissorTypes.LOWER)) {
                                    zones.find(x => x.zone === props.zones[i].name).scissor = 0
                                }

                                zones.find(x => x.zone === props.zones[i].name).used = true
                                zones.find(x => x.zone === props.zones[i].name).orderId = orders[o].id
                                zones.find(x => x.zone === props.zones[i].name).orderRef = orders[o].reference
                            }
                        }
                    }
                }
            }

            zones = zones.filter(x => x.used)

            if (zones.length > 0) {
                setShowZones(true)
            }

            if (JSON.stringify(zones) !== JSON.stringify(usedZones)) {
                setUsedZones(zones)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [props]);


    const changeZone = (zone) => {
        let orderId = usedZones.find(x => x.zone === zone).orderId
        if (location.pathname.includes('qualitychecks')) {

            dataService.getOrderDetailsByOrderId(orderId).then(productionOrder => {
                dataService.getProductionOrderLineBOMOutProducedByBOMOutId(productionOrder.bomOut[0].id).then(bomOutProduced => {
                    let progress = Math.ceil(bomOutProduced.quantityProduced / productionOrder.bomOut[0].quantityOnCarrier)
                    history.push('/qualitychecks/' + progress + '/' + orderId);
                    props.actions.setSelectedZone(zone)
                }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }
        else {
            history.push('/order/' + orderId)
            props.actions.setSelectedZone(zone)
        }
    }

    function getZoneColor(zone) {

        if (usedZones.find(x => x.zone === zone.zone).scissor === 1) {
            if (upperScissorStatus.name === scissorStates.SCRAP) {
                return "#D84949";
            }
        }
        else {

            if (lowerScissorStatus.name === scissorStates.SCRAP) {
                return "#D84949"
            }
        }

        if (zone.zone === props.workstation.selectedZone) {
            return "#4654FB"
        }
        else {
            return "#000000"
        }
    }
    return <React.Fragment>
        {showZones === true && usedZones.length > 0 && upperScissorStatus && lowerScissorStatus ?
            <div className={"selectedLineContainer"}>
                <div className={"selectedLineInnerContainer"}>
                    <button className={classes.selectedLine} key={props.line}>{props.line}</button>
                    {usedZones.map((z, index) => {
                        return (
                            <button key={index} className={classes.selectedZoneButton} onClick={() => changeZone(z.zone)}>
                                <div className={classes.topScissor}>
                                    {z.scissor === 1 ? <ArrowDropUpIcon className={classes.topScissorIcon}></ArrowDropUpIcon> : <React.Fragment></React.Fragment>}
                                </div>
                                <div style={{ bottom: z.scissor === 1 && "16px", color: getZoneColor(z) }} className={clsx({ [classes.zoneSelected]: props.workstation.selectedZone === z.zone, [classes.zoneNotSelected]: props.workstation.selectedZone !== z.zone })}> {z.zone}</div>

                                <div className={classes.bottomScissor}>
                                    {z.scissor === 0 ? <ArrowDropDownIcon className={classes.bottomScissorIcon}></ArrowDropDownIcon> : <React.Fragment></React.Fragment>}
                                </div>
                            </button>)
                    }
                    )}
                </div>
            </div>
            : <button className={classes.selectedLineNoZones} key={props.id}>{props.line}</button>} 
    </React.Fragment>
}

const useStyles = makeStyles({
    selectedLine: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#4654FB",
        backgroundColor: "#E6E8FE",
        display: "inline-block",
        outline: "none",
        border: "1px solid white",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
    },
    selectedLineNoZones: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#4654FB",
        backgroundColor: "#E6E8FE",
        display: "inline-block",
        outline: "none",
        border: "1px solid white",
        borderRadius: "50%",
        width: "30px",
        height: "30px",
    },
    selectedZoneButton: {
        display: "inline",
        width: "30px",
        height: "30px",
        border: "none",
        outline: "none",
        cursor: "pointer",
        backgroundColor: "rgb(1,1,1,0)"

    },
    selectedLineContainer: {
        display: "inline-block",
        height: "32px",
        borderRadius: "16px",
        backgroundColor: "white"
    },
    zoneSelected: {
        height: "22px",
        width: "22px",
        borderRadius: "50%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        backgroundColor: "#E6E8FE",
        position: "relative",
        paddingTop: "2px",
        boxSizing: "border-box"
    },
    zoneNotSelected: {
        height: "22px",
        width: "22px",
        borderRadius: "50%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        backgroundColor: "white",
        paddingTop: "2px",
        boxSizing: "border-box",
        position: "relative"
    },
    topScissorIcon: {
        position: "relative",
        bottom: "5px",
        height: "20px",
        width: "20px",
        left: "1px",
        zIndex: "1",
        color: FlagstoneTheme.palette.primary.main,
    },
    bottomScissorIcon: {
        position: "relative",
        bottom: "12px",
        left: "1px",
        zIndex: "1",
        height: "20px",
        width: "20px",
        backgroundColor: "rgb(1,1,1,0)",
        color: FlagstoneTheme.palette.primary.main,
    },


});